/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import { put } from 'redux-saga/effects';
import { StartupActions } from '../Redux/StartupRedux';

export function* startup() {
  let response = null;

  yield axios
    .get('/api/v1/meta')
    .then(({ data }) => {
      response = data;
      // put(StartupActions.setUser(response?.payload?.user));
    })
    .catch((error) => ({ error }));

  yield put(StartupActions.setUser(response?.payload?.user));
}
export default { startup };
